import { Component } from '@angular/core';

@Component({
    selector: 'app-change-orders-request-wrapper',
    templateUrl: './change-orders-request-wrapper.component.html',
    styleUrls: ['./change-orders-request-wrapper.component.scss'],
    standalone: false
})
export class ChangeOrdersRequestWrapperComponent {

}
